import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import htmlReactParser from 'html-react-parser';

const InfoBox = forwardRef((props, ref) => {
	const { title, description, link, readMore } = props;
	return (
	    <div className="B10-topic-selector__info-box" ref={ref}>
			<span className="B10-topic-selector__info-title">{title}</span>
			<p>{ htmlReactParser(description) }</p>
			<a className="btn btn--secondary" href={link}>
				{ readMore }
				<span className="btn__arrow-angle" />
			</a>
		</div>
	);
});

InfoBox.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	link: PropTypes.string,
	readMore: PropTypes.string,
};

InfoBox.defaultProps = {
	title: 'Title',
	description: 'Description',
	link: '#',
	readMore: 'Read more',
};

export default InfoBox;
